import styled from 'styled-components'

export const Subtitle = styled.p`
  color: var(--text-tertiary);
  font-size: var(--font-size-sm);
  font-weight: 400;
`

export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`
export const CursorPointerLink = styled.div`
  cursor: pointer;
`
